import Box from "@mui/material/Box";
import { Control } from "react-hook-form";
import { PatientFormValues } from "../patient-form.component";
import SelectFormField from "components/select-form-field";
import { BAS } from "constants/patients";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

type SexFieldProps = {
  control: Control<PatientFormValues, object>;
  required?: boolean;
};

export default function SexField({ control, required = false }: SexFieldProps) {
  return (
    <Box display="flex" justifyContent="space-between">
      <PersonOutlineOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
      <SelectFormField
        label="Sex"
        name="sex"
        control={control}
        options={BAS.getOptions()}
        required={required}
      />
    </Box>
  );
}
